<template>
  <div>
    <modal
      name="NotiWritePopup"
      width="1024px"
      height="auto"
      :scrollable="true"
      :clickToClose="false"
    >
      <div id="News_popup">
        <div class="popup_bar">
          <h4>공고 추가</h4>
          <a @click="btnClose" class="btn_close"></a>
        </div>

        <ul class="contents">
          <li class="tit">제목</li>
          <li class="tit_input">
            <input type="text" v-model="title" />
          </li>

          <!-- <li>내용</li> -->
          <li class="editor">
            <vue-editor v-model="content"></vue-editor>
          </li>
        </ul>

        <ul class="contents">
          <li class="tit">작성자</li>
          <li class="tit_input">
            <input type="text" v-model="writer" />
          </li>
        </ul>

        <ul>
          <li class="input">
            <file-upload
              input-id="file"
              ref="upload2"
              v-model="files"
              :drop="true"
              :multiple="true"
            >
              <h4>첨부하실 파일을 선택하거나 마우스로 끌어서 넣어주세요.</h4>
              <h4>※ 다운로드용 파일 입니다.</h4>
            </file-upload>

            <div v-if="files.length">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>파일이름</th>
                    <th>크기</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fileObj in files" :key="fileObj.id">
                    <td>
                      <img
                        v-if="fileObj.thumb"
                        :src="fileObj.thumb"
                        width="40"
                        height="auto"
                      />
                      <img
                        v-else
                        :src="fileIcon(fileObj.name)"
                        width="40"
                        height="auto"
                      />
                    </td>
                    <td>{{ fileObj.name }}</td>
                    <td>{{ fileObj.size | formatSize }}</td>
                    <td>
                      <button @click.prevent="$refs.upload2.remove(fileObj)">
                        삭제
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>
        </ul>

        <p class="btn_area">
          <button class="btn_link" @click="btnSave">저장</button>
          <button class="btn_link type02" @click="btnClose">취소</button>
        </p>
      </div>
    </modal>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import FileUpload from "vue-upload-component";
import pm from "../common/protocolManager";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { getThumbIcon } from "../common/util";
import eventBus from "../common/eventBus";

export default {
  components: {
    VueEditor,
    FileUpload
  },
  data: () => ({
    message: "NotiWritePopup.vue",
    EDIT_MODE: false,
    id: "",
    title: "",
    content: "",
    writer: "",
    files: [],
    saveFiles: []
  }),
  methods: {
    fileIcon(fileName) {
      return getThumbIcon(fileName);
    },
    deleteBgFile(obj) {
      console.log("deleteBgFile");
      this.files = [];
    },
    deleteFiles(obj) {},
    btnSave() {
      console.log("btnSave");

      if (this.title == "") {
        alert("제목이 필요합니다.");
        return;
      }

      if (this.writer == "") {
        alert("작성자 명이 필요합니다.");
        return;
      }

      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("writer", this.writer);
      formData.append("content", this.content);

      // bg image
      for (let i = 0; i < this.files.length; i++) {
        if (typeof this.files[i].file != "undefined") {
          formData.append("file", this.files[i].file);
        }
      }

      let url = "ferrum/insertNoti";
      if (this.EDIT_MODE) {
        url = "ferrum/updateNoti";
        formData.append("_id", this.id);

        //formData.append("saveFiles", JSON.stringify(this.saveFiles));
      }
      pm.fileUpload(url, formData)
        .then(result => {
          console.log("test1 - ok");
          alert("공고 등록 성공");
          eventBus.$emit("EVENT_CHANGE_NOTI");
          this.btnClose();
        })
        .catch(err => {
          alert("공고 등록 에러");
          console.log("test1 - error");
        });
    },
    btnClose() {
      console.log("btnClose");
      this.$modal.hide("EventPopup");
      this.$router.go(-1);
    }
  },
  mounted() {
    this.$modal.show("NotiWritePopup");
  },
  computed: {},
  destroyed() {},
  created() {
    if (this.$route.params.write == 1) {
      console.log("this.$route.params.write = " + this.$route.params.write);
      this.EDIT_MODE = true;
      let detailObj = this.$localStorage.get("notiDetailObj");
      this.id = detailObj.id;
      this.title = detailObj.title;
      this.content = detailObj.content;
      this.writer = detailObj.writer;
      this.saveFiles = detailObj.files.file;

      /*
      id:"",
    title: "",
    content: "",
    writer: "",
    files: [],
    saveFiles: []
    */

      //this.reqDetail();
    }
    console.log("created - " + this.message);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sub05/writeNoti.vue